export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6846.aad6537a.jpg";